import React from 'react';

import Breadcrumbs from 'Components/Breadcrumbs';
import GameContext from 'Containers/GameContext';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import { ROUTES } from 'Settings/route-strings';

const GameBreadcrumbs = ({ slug, promoBannerIsVisible }) => {
  return (
    <Breadcrumbs
      title={<ConnectedFormattedMessage id={`model.${slug}.title`} />}
      id={slug}
      route={ROUTES.EXPLORE}
      modifierClass={promoBannerIsVisible ? 'extra-padding' : null}
    />
  );
};

export default GameContext(GameBreadcrumbs);
